/** Ground-anchored opening-area architecture. Frames contain only visual art;
 * passage collision, the Hearth roof and all services remain map-owned.
 */
export const OPENING_AREA_PROP_TEMPLATES = {
  vault_archway: { kind: 'gate', name: 'Carved vault archway', frame: { w: 400, h: 380 }, band: 'architecture' },
  vault_ossuary: { kind: 'colonnade_column', name: 'Recessed vault ossuary', frame: { w: 120, h: 340 }, band: 'architecture' },
  hearth_well_frame: { kind: 'village_well', name: 'Roofless Hearth well frame', frame: { w: 180, h: 250 }, band: 'architecture' },
} as const;

export type OpeningAreaPropTemplate = keyof typeof OPENING_AREA_PROP_TEMPLATES;
